import type { EventSourceMessage } from '@microsoft/fetch-event-source';

export enum ReadyState {
  Connecting = 0,
  Open,
  Closing,
  Closed,
}
export interface SSEOptions<T = any> {
  method?: 'GET' | 'POST';
  headers?: Record<string, string>;
  withCredentials?: boolean;
  retryLimit?: number; // 最大重试次数
  retryInterval?: number; // 重试间隔（毫秒）
  onOpen?: (response: Response) => void;
  onClose?: () => void;
  onMessage?: (message: T, event: EventSourceMessage) => void;
  onError?: (error: Error, retryCount: number) => void | number; // 返回自定义重试间隔
}

export interface SSEResult {
  readyState: ReadyState;
  sendMessage: (body?: any, queryParams?: Record<string, string | number | boolean>) => void;
  disconnect: () => void;
  latestEvent?: EventSourceMessage;
  error?: Error;
  retryCount: number; // 当前重试次数
}
